<template>
    <div>
        <div class="modal fade" id="myAccountJm" tabindex="-1" aria-labelledby="myAccountJmLabel" aria-hidden="true"
            data-bs-backdrop="false" style="background-color:rgba(0, 0, 0, 0.5);">
            <div class="modal-dialog modal-fullscreen">
                <div class="modal-content data-container" :style="skin.my_account.modal_background">
                    <div class="modal-body row">
                        <span class="modal-header2 ">{{ translate('welcome') }} !</span>
                        <button id="closemyAccountJm" :style="skin.my_account.close_btn" type="button" class="btn-close modal-header2"
                                data-bs-dismiss="modal" aria-label="Close"><i class="fas fa-times"></i></button>
                        <div class="col-lg-4 col-xl-4 col-sm-12">
                            <div class="user-info p-4" :style="skin.header_desktop.nav_bar_text+skin.my_account.main_background" style="position: relative;">
                                <img v-if="skin.imagen.account" :src="skin.imagen.account" alt="" class="mascot2">
                                <div class="d-flex">
                                    <div style="width: 10%;">
                                        <span><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM6.023 15.416C7.491 17.606 9.695 19 12.16 19C14.624 19 16.829 17.607 18.296 15.416C16.6317 13.8606 14.4379 12.9968 12.16 13C9.88171 12.9966 7.68751 13.8604 6.023 15.416ZM12 11C12.7956 11 13.5587 10.6839 14.1213 10.1213C14.6839 9.55871 15 8.79565 15 8C15 7.20435 14.6839 6.44129 14.1213 5.87868C13.5587 5.31607 12.7956 5 12 5C11.2044 5 10.4413 5.31607 9.87868 5.87868C9.31607 6.44129 9 7.20435 9 8C9 8.79565 9.31607 9.55871 9.87868 10.1213C10.4413 10.6839 11.2044 11 12 11Z" fill="#EDEDED"></path></svg></span>
                                    </div>
                                    <div class="py-1" style="line-height: 3px;width: 90%;position: relative;">
                                        <span class="user-name mx-3">ID: {{ user.user_data.data ? user.user_data.data.user_id : '' }}</span><br>
                                        <span class="user-name mx-3">{{ user.user_data.data ? user.user_data.data.user_name : '' }}</span>
                                        <span @click="logout" style="float: right;position:absolute;right: 0;top:0;cursor: pointer;"><svg style="width: 2rem;height: 2rem;" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 10L24 14M24 14L20 18M24 14H11M17 6.20404C15.7252 5.43827 14.2452 5 12.6667 5C7.8802 5 4 9.02944 4 14C4 18.9706 7.8802 23 12.6667 23C14.2452 23 15.7252 22.5617 17 21.796" stroke="white" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>
                                    </div>
                                </div>
                                <div class="my-4">
                                    <span>{{ translate('balance2') }}:</span><br>
                                    <span class="modal-header2">${{ user.user_data.data ? new Intl.NumberFormat("de-DE",{minimumFractionDigits: skin.qBet_config.decimalsQty,maximumFractionDigits: skin.qBet_config.decimalsQty}).format(balance) : 0 }}</span>
                                </div>
                                <div class="my-4">
                                    <span>{{ translate('bonus_balance') }}:</span><br>
                                    <span class="modal-header2">${{ user.user_data.data ? new Intl.NumberFormat("de-DE",{minimumFractionDigits: skin.qBet_config.decimalsQty,maximumFractionDigits: skin.qBet_config.decimalsQty}).format(bonos) : 0 }}</span>
                                </div>
                                <div class="my-4">
                                    <span>{{ translate('frozen_balance') }}:</span><br>
                                    <span class="modal-header2">${{ user.user_data.data ? new Intl.NumberFormat("de-DE",{minimumFractionDigits: skin.qBet_config.decimalsQty,maximumFractionDigits: skin.qBet_config.decimalsQty}).format(frozen) : 0 }}</span>
                                </div>
                                <div v-if="skin.retiro" class="my-4">
                                    <button id="submit" type="submit" class="p-2 login-btn btn" :style="skin.header_desktop.nav_bar_text+skin.header_desktop.selection" @click="retirar">{{ translate('Retirar') }}</button>
                                </div>
                            </div>
                            <div class="user-info p-4 my-3" :style="skin.header_desktop.nav_bar_text+skin.my_account.content_background" style="position: relative;">
                                <div>
                                    <span class="me-2">
                                        <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M8 10H6C4.89543 10 4 10.8954 4 12V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V12C20 10.8954 19.1046 10 18 10H16M8 10V7C8 4.79086 9.79086 3 12 3V3C14.2091 3 16 4.79086 16 7V10M8 10H16M12 14V17" :stroke="skin?.main_modal_background" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path></g></svg>
                                    </span>
                                        
                                        <span class="user-name">{{ translate('password_ganamos') }}</span>
                                </div>
                                <div class="">
                                    <span v-if="showChangePassword">{{ translate('sugerencia') }}</span><br>
                                    <form @submit.prevent="changePassword()">
                                        <label for="password">{{ translate('new_password') }} <span style="color: red;">*</span></label>
                                        <div class="search-filter-slots-desktop__input-wrapper" :style="skin.side_bar.body">
                                            <div class="search-filter-slots-desktop__input">
                                                <div class="input-desktop" :style="skin.side_bar.body"> 
                                                <input id="passwordJm" v-model="password" autocomplete="off" required
                                                class="input-desktop__native input-desktop__native_color_default input-desktop__native_type_search-slots"
                                                type="password" name="slots-search" :placeholder="translate('enter_password')" value="" :style="skin.side_bar.body"></div>
                                            </div>
                                            <span @click="show_hide_Password('passwordJm')" style="cursor: pointer;;width: 30px;">
                                                <svg style="width: 1.5rem;" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.257 10.962C21.731 11.582 21.731 12.419 21.257 13.038C19.764 14.987 16.182 19 12 19C7.81801 19 4.23601 14.987 2.74301 13.038C2.51239 12.7411 2.38721 12.3759 2.38721 12C2.38721 11.6241 2.51239 11.2589 2.74301 10.962C4.23601 9.013 7.81801 5 12 5C16.182 5 19.764 9.013 21.257 10.962V10.962Z" stroke="#76657E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="#76657E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                            </span>
                                        </div><br>
                                        <label for="password">{{ translate('repeat_password') }} <span style="color: red;">*</span></label>
                                        <div class="search-filter-slots-desktop__input-wrapper" :style="skin.side_bar.body">
                                            <div class="search-filter-slots-desktop__input" >
                                                <div class="input-desktop" :style="skin.side_bar.body">
                                                <input id="passwordJm2" v-model="password2" autocomplete="off" required
                                                class="input-desktop__native input-desktop__native_color_default input-desktop__native_type_search-slots"
                                                type="password" name="slots-search" :placeholder="translate('pass')" value="" :style="skin.side_bar.body"></div>
                                            </div>
                                            <span @click="show_hide_Password('passwordJm2')" style="cursor: pointer;width: 30px;">
                                                <svg style="width: 1.5rem;" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.257 10.962C21.731 11.582 21.731 12.419 21.257 13.038C19.764 14.987 16.182 19 12 19C7.81801 19 4.23601 14.987 2.74301 13.038C2.51239 12.7411 2.38721 12.3759 2.38721 12C2.38721 11.6241 2.51239 11.2589 2.74301 10.962C4.23601 9.013 7.81801 5 12 5C16.182 5 19.764 9.013 21.257 10.962V10.962Z" stroke="#76657E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="#76657E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                            </span>
                                        </div>
                                        <br>
                                        <div class="" style="cursor:pointer;overflow: hidden;border-radius: 6.25rem;">
                                            <button id="submit" type="submit" class="p-2 login-btn btn" :style="skin.header_desktop.nav_bar_text+skin.header_desktop.selection" :disabled="login_inProcess">{{ translate('restore') }}</button>
                                        </div>
                                    </form>
                                    <div v-if="status.message!=''" :class="'alert alert-'+status.type" role="alert">{{ status.message }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8 col-xl-8 col-sm-12">
                            <div class="user-info p-4" :style="skin.header_desktop.nav_bar_text+skin.my_account.content_background" style="position: relative;">
                                <div v-if="loading_report" style="width:100%" class="text-center p-2">
                                    <div class="spinner-border" style="color:white" role="status">
                                        <span class="visually-hidden">{{ translate('loading') }}</span>
                                    </div>
                                </div>
                                <div class="" style="cursor:pointer;overflow: hidden;border-radius: 6.25rem;">
                                    <button @click="getData()" class="p-2 login-btn btn" :style="skin.header_desktop.nav_bar_text+skin.header_desktop.selection" :disabled="loading_report">{{ translate('movi1') }}</button>
                                </div>
                                <div class="table-responsive">
                                    <table class="table" style="color:white;font-size: 15px;">
                                        <thead>
                                            <tr>
                                                <th scope="col">{{ translate('date') }}</th>
                                                <th scope="col">{{ translate('supplier') }}</th>
                                                <th scope="col">{{ translate('detail') }}</th>
                                                <th scope="col">{{ translate('amount1') }}</th>
                                                <th scope="col">{{ translate('balance2') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in paginarArray(report, registers_per_page)[actual_page - 1]" :key="index">
                                                <td>{{ formatearFecha(item.fecha) }}</td>
                                                <td>{{ item.proveedor }}</td>
                                                <td>{{ item.operacion }}</td>
                                                <td>{{ parseNumbers(item.valor) }}</td>
                                                <td>{{ parseNumbers(item.nuevo_capital) }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div>
                                    <pagination class="float-end" :options="paginationConf" v-model="actual_page" :records="records" :per-page="registers_per_page" @paginate="paginate"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <button id="retirar_btn" class="btn btn-primary" data-bs-toggle="modal" href="#retirarModalToggle"
        style="display:none;"></button>
        <Retirar v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
    </div>
</template>
  
<script>
import Pagination from 'vue-pagination-2';
import Retirar from './retirar.vue';
import MyPagination from './Pagination.vue'
import axios from 'axios';
export default {
    name: "myAccountJm",
    props: ['skin', 'translation', 'language'],
    components:{Pagination,Retirar},
    data() {
        return {
            balance:0,
            bonos:0,
            frozen:0,
           report:[],
            actual_page:1,
            records:0,
            registers_per_page:10,
            paginationConf:{
                texts:{count:''},
                template:MyPagination
            },
            loading_report:false,
            password:"",
            password2:"",
            show1:true,
            show2:true,
            status:{
                message:"",
                type:""
            },
            login_inProcess:false
        }
    },
    computed: {
        user(){
            let data = this.$store.getters['getUserData'];
            if(data.user_data.data){
                this.balance = data.user_data.data.balance;
                this.bonos = data.user_data.data.balance_bonus;
                this.frozen = data.user_data.data.balance_frozen;
            }
            return data;
         },
         showChangePassword(){
            return this.$store.getters['getShowChangePassword'];
        },
        apiUrlnew(){
            return this.$store.getters['getApiUrlnew'];
        },
        site(){
            return this.$store.getters['getSite'];
        },
    },
    methods: {
        retirar() {
            document.getElementById('retirar_btn').click();
        },
        paginate(page){
            this.actual_page = page;
        },
        paginarArray(array, elementosPorPagina) {
            const paginas = [];
            let paginaActual = [];

            for (let i = 0; i < array.length; i++) {
                if (paginaActual.length === elementosPorPagina) {
                    paginas.push(paginaActual);
                    paginaActual = [];
                }
                paginaActual.push(array[i]);
            }

            if (paginaActual.length > 0) {
                paginas.push(paginaActual);
            }
            this.records = array.length;
            this.pages = paginas;
            return paginas;
        },
        logout(){
            this.$store.dispatch('logOut');
            this.$root.$emit('forceRender');
        },
        async getData() {
            this.loading_report=true;
            let data = await axios.post(this.apiUrlnew +"historial_jugador", {
                "username": this.user.user_data.data.user_name,
                "startDate": "2020-01-01 00:00:00",
                "endDate": "2030-12-31 23:59:59",
                "token":this.user.token,
                "timezone": "-05:00",
                "site": this.site
            })
            this.report = data.data
            this.loading_report=false;
        },
        parseNumbers(number){
            return new Intl.NumberFormat("de-DE",{minimumFractionDigits:2, maximumFractionDigits: 2}).format(number)
        },  
        formatearFecha(fechaString) {
            const fecha = new Date(fechaString);
            const anio = fecha.getFullYear();
            const mes = this.agregarCeroDelante(fecha.getMonth() + 1);
            const dia = this.agregarCeroDelante(fecha.getDate());
            const Hora = this.agregarCeroDelante(fecha.getHours());
            const Minutos = this.agregarCeroDelante(fecha.getMinutes());
            const Segundos = this.agregarCeroDelante(fecha.getSeconds());
            return `${anio}/${mes}/${dia} ${Hora}:${Minutos}:${Segundos}`;
        },
        agregarCeroDelante(numero) {
            return numero < 10 ? '0' + numero : numero;
        },
        async changePassword(){
                try {
                    this.login_inProcess = true;
                    let data = await axios.post(this.apiUrlnew +"cambiar_password", 
                    {
                        "users": [this.user.user_data.data.user_id ?? this.user.user_data.data.id],
                        "password": this.password,
                        "password1": this.password2,
                        "token":this.user.token,
                        "login_id":this.user.user_data.data.user_id ?? this.user.user_data.data.id,
                        "site": this.site
                    })
                    if(data.data.error){
                        this.status.message = data.data.error;
                        this.status.type = "danger";
                    }
                    else{
                        this.status.message = data.data.message;
                        this.status.type = "success";
                        this.logout();
                        setTimeout(()=>{
                            document.getElementById("closemyAccountJm").click();
                        },2000)
                    }
                    this.login_inProcess = false;
                } catch (error) {
                    this.status.message = error.response.data.error;
                    this.status.type = "danger";
                    this.login_inProcess = false;
                }
                
          },
          translate(text) {
              if(text){
                  if (this.$props.translation[text]) {
                      return this.$props.translation[text][this.$props.language];
                  }
                  else{
                      var new_text_serched = text.replace(/ /g, "_");
                      if (this.$props.translation[new_text_serched]) {
                          return this.$props.translation[new_text_serched][this.$props.language];
                      }
                  }
                  return text;
              }
          },
          show_hide_Password(target){
            if(target == "password"){
                document.getElementById(target).type = this.show1?"text":"password";
                this.show1 = !this.show1;
            }
            else{
                document.getElementById(target).type = this.show2?"text":"password";
                this.show2 = !this.show2;
            }
          },
    },
    mounted() {
        // this.$root.$on('getMovementsHistory', () => {
        //     this.getData(); 
        // });
    }
}
</script>
  
<style scoped>
.modal-header2 {
    color: #fff;
    font-size: 2.375rem;
    font-weight: 600;
    line-height: 2.783rem;
    font-family: "Roboto", Arial, sans-serif;
}
.user-info{
    border-radius: 1.5rem;
    overflow: hidden;
    width: 100%;
}
.user-name{
    color: #ededed;
    font-size: 1rem;
    line-height: 1rem;
    font-weight: 600;
}
.mascot2{
    position: absolute;
    width: 9.099rem;
    height: 13.016rem;
    bottom: 0;
    right: .938rem;
 }
 .search-filter-slots-desktop__input-wrapper{
    -webkit-box-flex: 2;
    -ms-flex-positive: 2;
    flex-grow: 2;
    height: 40px;
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-right: .625rem;
    /* background: linear-gradient(180deg, #320548 0%, #1f073a 100%); */
    /* border: var(--border); */
    border-radius: 6.25rem;
    overflow: hidden;
    position: relative;
    overflow: hidden;
    padding-left: .938rem;
}
.search-filter-slots-desktop__search-icon {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
.search-filter-slots-desktop__input {
    -webkit-box-flex: 2;
    -ms-flex-positive: 2;
    flex-grow: 2;
}
.input-desktop {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    position: relative;
}
.login-btn{
    width: 100%;
    border: none;
}
.search-filter-slots-desktop__input input {
    padding-left: .625rem;
    border: none;
    /* background: #130227; */
    color: var(--color);
    font-weight: 600;
    font-size: .875rem;
}
.input-desktop__native {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 0 1.25rem;
    outline: none;
    border-radius: 5px;
    /* background: #130227; */
    color: white;
    font-family: "Roboto", Arial, sans-serif;
    font-size: .875rem;
    font-weight: 700;
    line-height: .875rem;
}
.btn-close{
    background:transparent;
    position: absolute;
    top: 20px;
    right: 20px;
    color:white;
}
.data-container{
    padding: 1.25rem 20.625rem 0 20.625rem;
}
@media only screen and (max-width: 700px) {
    .data-container{
        padding: 0;
    }
    .modal-header2 {
        font-size: 1rem;
    }
}
</style>